/**
 * IMPORTS
 */

import { useEffect, useMemo, useState } from "react";

import debounce from "lodash.debounce";
import { Search } from "lucide-react";

// components
import { ClearInputButton } from "@/presentation/components/clear-input-button";
import { Input } from "@/presentation/components/input/input";

// store zustand
import { useStoreZustandRecepcao } from "@/store-zustand/recepcao/recepcao";

function SearchInputRecepcao() {
  const { searchItem, setSearchItem, setCurrentPage } = useStoreZustandRecepcao();
  const [value, setValue] = useState(searchItem ?? "");

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm: string) => {
        setCurrentPage(1);
        setSearchItem(searchTerm);
      }, 400),
    [setSearchItem, setCurrentPage]
  );

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value;
    setValue(searchTerm);
    if (searchTerm.length >= 3 || searchTerm.length === 0) {
      debouncedSearch(searchTerm);
    }
  };

  const handleClear = () => {
    setValue("");
    debouncedSearch("");
    debouncedSearch.flush();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      debouncedSearch.flush();
    }
  };

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  return (
    <form className="relative ml-auto flex-1 md:grow-0">
      <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 transform text-muted-foreground" />
      <Input
        id="search-input"
        aria-label="Pesquisar remessas"
        name="q"
        type="search"
        placeholder="Pesquisar..."
        className="w-full rounded-lg bg-background pl-8 pr-12 focus:outline-none md:w-[200px] lg:w-[336px]"
        value={value}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
      />
      {value && <ClearInputButton onClick={handleClear} />}
    </form>
  );
}

/**
 * EXPORTS
 */
export { SearchInputRecepcao };
